import React from 'react';
import {useIntl} from 'react-intl';
import {PageTitle} from '../../../_metronic/layout/core';
import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getServicesByClient} from '../Api/api';
import MessagerieServices from '../Components/MessagerieServices';

const MessageriePage = (): JSX.Element => {
  const intl = useIntl();

  const {isLoading, data: services} = useQuery<ListService[]>(
    ['get-service-by-client-mail'],
    () => getServicesByClient('MAIL'),
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CLOUD.GROUP_EMAILS'})}</PageTitle>
      <MessagerieServices isLoading={isLoading} services={services} />
    </>
  );
};

export default MessageriePage;
